import React from "react";
import { ReorderingTypes } from "./modules/ReorderOfferings/ReorderOffferings";
import { useCustomizationStore } from "./store/useCustomizationStore";
import ExlyLoader from "ui/modules/ExlyLoader";
import { SectionWrapper } from "features/AdminPanel/modules/SectionWrapper/SectionWrapper";
import { SubSectionWrapper } from "features/Account/modules/SubSectionWrapper/SubSectionWrapper";
import useDesktopMediaQuery from "hooks/useDesktopMediaQuery";
import ExlyImage from "common/Components/ExlyImage";
import { useWebpageCustomizationConfig } from "./common/utils/useWebpageCustomizationConfig";
import { getRAUrlParams } from "features/Common/utils/url.utils";
import { CUSTOMIZATION_SECTIONKEYS } from "./common/utils/Customization.constants";
import {
  HOMEPAGE_URL_QUERY_PARAMS,
  HOMEPAGE_BUILDER_MODE_VALUES,
} from "features/HomepageBuilder/constants/HomepageBuilder.constants";

export const Customizations = (props) => {
  const config = useWebpageCustomizationConfig();
  const sectionLoaded = useCustomizationStore((state) => state.sectionConfig);

  const isDesktop = useDesktopMediaQuery();
  const isAdvancedBuilder =
    getRAUrlParams().get(HOMEPAGE_URL_QUERY_PARAMS.builder) ===
    HOMEPAGE_BUILDER_MODE_VALUES.advanced;

  if (!sectionLoaded) {
    return <ExlyLoader />;
  }

  const visibleConfig = config.filter(
    (section) =>
      !(
        [
          CUSTOMIZATION_SECTIONKEYS.BRAND_ASSETS,
          CUSTOMIZATION_SECTIONKEYS.CUSTOM_FOOTER,
        ].includes(section.key) && !isAdvancedBuilder
      )
  );

  return (
    <div className="tw-font-['Helvetica_Neue'] tw-m-0 md:tw-m-8">
      <ReorderingTypes {...props} />
      {visibleConfig.map((section, index) => {
        return (
          <div className="tw-flex tw-items-start tw-gap-5" key={section.title}>
            {isDesktop && (
              <ExlyImage
                src={section.icon}
                className="tw-w-10 tw-hidden md:tw-block tw-py-6 "
              />
            )}
            <SectionWrapper
              key={section.title}
              className="tw-flex-1 tw-min-w-0"
              config={section}
              showDivider={isDesktop && index !== visibleConfig.length - 1}
              customJSX={<SubSectionWrapper section={section} />}
            />
          </div>
        );
      })}
    </div>
  );
};
